import odata from "@/core/api/mixin/odata";
import rest from "@/core/api/mixin/rest";
import { apiClient } from "@/core/api/httpClient";

export default {
  ...odata("exports"),
  ...rest("exports"),

  createRequest: function (payload) {
    return apiClient.post(payload.url, payload.request);
  },
};
